import { Tooltip, Typography } from "@pankod/refine-antd";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime); // Enable relative time plugin

// Function to display a timestamp in a specific format or as a default format
// If a format is provided, it uses that; otherwise, it defaults to "lll"
export function displayTimestamp(date?: dayjs.ConfigType, format?: string) {
    return (
        format ?
            <Typography.Text> {dayjs(date).format(format)} </Typography.Text> :
            <Typography.Text> {dayjs(date).format("lll")} </Typography.Text>
    );
}

// Function to display a relative date with a tooltip showing the full date
// It uses dayjs to format the date and display how long ago it was from now
export function displayRelativeDate(date?: dayjs.ConfigType) {
    return (
        <Tooltip title={dayjs(date).format("lll")}>
            <Typography.Text style={{ color: "GrayText" }}> {dayjs(date).fromNow()} </Typography.Text>
        </Tooltip>
    );
}

// Function to display a relative date with a tooltip showing the full date
// It uses dayjs to format the date and display how long ago it was from now
export function displayElapsedTime(date?: dayjs.ConfigType) {
    return (
        <Tooltip title={dayjs(date).format("lll")}>
            <Typography.Text style={{ color: "GrayText" }}> {dayjs(date).toNow().replace("in", "")} </Typography.Text>
        </Tooltip>
    );
}